
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { slice } from 'lodash';

import { DEFINITION_OPSUB } from '../../common/common/iskn/opsub';
import { DEFINITION_PAR } from '../../common/common/iskn/par';
import { DEFINITION_TEL } from '../../common/common/iskn/tel';

import { getIsSearchLoading, getSearchData } from '../../reducers/search';

import IfComp from '../common/IfComp';
import PanelTitle from '../common/PanelTitle';

import IsknObjectListStatus from './IsknObjectListStatus';
import IsknObjectListOpsub from './IsknObjectListOpsub';
import IsknObjectListPar from './IsknObjectListPar';
import IsknObjectListTel from './IsknObjectListTel';

const classNames = mergeStyleSets({
    objectList: {
        overflowY: 'auto',
        height: 100 // fix
    },
});

const IsknObjectList = ({isknDate, objectType}) => {

    const [trim, setTrim] = React.useState(true);

    const BATCH_SIZE = 100;

    const isSearchLoading = useSelector(state => getIsSearchLoading(state.search));
    const data = useSelector(state => getSearchData(state.search, objectType));
    const preparedData = (trim)
        ? slice(data || [], 0, BATCH_SIZE)
        : [...data];

    const trimmed = ((data || []).length > preparedData.length);

    React.useEffect(() => {
        setTrim(true);
    }, [data]);

    const handleShowAllClick = () => {
        setTrim(false);
    }

    return (
        <Stack verticalFill>
            <Stack.Item>
                <PanelTitle title="Seznam vyhledaných objektů" />
            </Stack.Item>
            <Stack.Item grow className={classNames.objectList}>
                <IfComp cond={objectType === DEFINITION_OPSUB.objectType} >
                    <IsknObjectListOpsub
                        data={{opsub: preparedData}}
                        isknDate={isknDate}
                        loading={isSearchLoading}
                    />
                </IfComp>
                <IfComp cond={objectType === DEFINITION_PAR.objectType} >
                    <IsknObjectListPar
                        data={{par: preparedData}}
                        isknDate={isknDate}
                        loading={isSearchLoading}
                    />
                </IfComp>
                <IfComp cond={objectType === DEFINITION_TEL.objectType} >
                    <IsknObjectListTel
                        data={{tel: preparedData}}
                        isknDate={isknDate}
                        loading={isSearchLoading}
                    />
                </IfComp>
            </Stack.Item>
            <Stack.Item>
                <IfComp cond={(data || []).length > 0}>
                    <IsknObjectListStatus
                        data={data || []}
                        preparedData={preparedData}
                        trimmed={trimmed}
                        onShowAllClick={handleShowAllClick}
                    />
                </IfComp>
            </Stack.Item>
        </Stack>
    );
}

export default IsknObjectList;
